module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp23_6005.acd6a42f.png";